import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

function openAuthBlob(url, fallbackType) {
  const tab = window.open('about:blank', '_blank')
  return axiosIns
    .get(url, { responseType: 'blob' })
    .then(response => {
      const type = (response.headers && response.headers['content-type']) || fallbackType || 'application/octet-stream'
      if (type.indexOf('application/json') !== -1 || type.indexOf('text/html') !== -1) {
        if (tab) {
          tab.close()
        }
        return
      }
      const blob = new Blob([response.data], { type })
      const fileUrl = window.URL.createObjectURL(blob)
      if (tab) {
        tab.location.href = fileUrl
      } else {
        window.open(fileUrl, '_blank')
      }
    })
    .catch(() => {
      if (tab) {
        tab.close()
      }
    })
}

function loadAuthSrc(el, url) {
  if (!url) {
    return
  }
  axiosIns
    .get(url, { responseType: 'blob' })
    .then(response => {
      if (el.__authSrcUrl) {
        window.URL.revokeObjectURL(el.__authSrcUrl)
      }
      const type = (response.headers && response.headers['content-type']) || 'image/jpeg'
      if (type.indexOf('application/json') !== -1 || type.indexOf('text/html') !== -1) {
        return
      }
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type }))
      el.__authSrcUrl = blobUrl
      el.src = blobUrl
    })
    .catch(() => {})
}

Vue.prototype.$openPdf = function openPdf(url) {
  return openAuthBlob(url, 'application/pdf')
}

Vue.prototype.$openFile = function openFile(url) {
  return openAuthBlob(url)
}

Vue.directive('auth-src', {
  bind(el, binding) {
    loadAuthSrc(el, binding.value)
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      loadAuthSrc(el, binding.value)
    }
  },
  unbind(el) {
    if (el.__authSrcUrl) {
      window.URL.revokeObjectURL(el.__authSrcUrl)
    }
  },
})

export default axiosIns
